"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CashBack = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Bubble = _interopRequireDefault(require("../Bubble"));
var _MobilePopupBottom = _interopRequireDefault(require("../MobilePopupBottom"));
var _CashBackDefault = require("./CashBackDefault");
var _styles = require("./styles");
var _excluded = ["className", "cashbackTooltipText", "label", "isMobile", "size", "avatarPath", "hasCashbackLabel", "count", "cashbackIconWebp", "cashbackIconPng", "labelColor", "textColor"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CashBack = exports.CashBack = function CashBack(_ref) {
  var className = _ref.className,
    cashbackTooltipText = _ref.cashbackTooltipText,
    label = _ref.label,
    isMobile = _ref.isMobile,
    size = _ref.size,
    avatarPath = _ref.avatarPath,
    hasCashbackLabel = _ref.hasCashbackLabel,
    count = _ref.count,
    cashbackIconWebp = _ref.cashbackIconWebp,
    cashbackIconPng = _ref.cashbackIconPng,
    labelColor = _ref.labelColor,
    textColor = _ref.textColor,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showPopup = _useState2[0],
    setShowPopup = _useState2[1];
  var togglePopup = function togglePopup() {
    return setShowPopup(function (on) {
      return !on;
    });
  };
  var borderStyle = className !== null && className !== void 0 && className.includes('withBorder') ? '1px solid #000' : 'none';
  if (!cashbackTooltipText) {
    return /*#__PURE__*/_react["default"].createElement(_styles.FlexContainer, null, /*#__PURE__*/_react["default"].createElement(_CashBackDefault.CashBackDefault, {
      className: className,
      label: label,
      size: size,
      count: count,
      avatarPath: avatarPath,
      hasCashbackLabel: hasCashbackLabel,
      cashbackIconWebp: cashbackIconWebp,
      cashbackIconPng: cashbackIconPng,
      labelColor: labelColor,
      textColor: textColor
    }));
  }
  return isMobile ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.FlexContainer, {
    onClick: togglePopup,
    onKeyDown: togglePopup,
    className: className,
    "data-testid": "TEST_ID_CASHBACK_MOBILE_WITH_TOOLTIP"
  }, /*#__PURE__*/_react["default"].createElement(_CashBackDefault.CashBackDefault, {
    labelColor: labelColor,
    textColor: textColor,
    count: count,
    label: label,
    size: size,
    avatarPath: avatarPath,
    hasCashbackLabel: hasCashbackLabel,
    cashbackIconWebp: cashbackIconWebp,
    cashbackIconPng: cashbackIconPng,
    className: className
  })), /*#__PURE__*/_react["default"].createElement(_MobilePopupBottom["default"], {
    visible: showPopup,
    onClick: togglePopup
  }, cashbackTooltipText)) : /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
    text: cashbackTooltipText,
    width: 265,
    className: className,
    "data-testid": "TEST_ID_CASHBACK_DESKTOP_WITH_TOOLTIP"
  }, /*#__PURE__*/_react["default"].createElement(_CashBackDefault.CashBackDefault, {
    label: label,
    labelColor: labelColor,
    textColor: textColor,
    count: count,
    size: size,
    avatarPath: avatarPath,
    hasCashbackLabel: hasCashbackLabel,
    cashbackIconWebp: cashbackIconWebp,
    cashbackIconPng: cashbackIconPng,
    className: className
  }));
};